import { createUseMutationHook } from './createUseMutationHook';

export const useTripCreate = createUseMutationHook(
    'trip_create',
    () => [
        ['trip_list'],
    ],
);
